<template>
  <div class="shoppe">
    <div class="upload-container">
      <el-upload
        :headers="uploadHeader"
        :action="importUrl"
        :on-error="handleError"
        :on-success="handleSuccess"
        :file-list="fileList">
        <el-button size="small" type="primary">请上传附件</el-button>
        <div slot="tip" class="el-upload__tip">只支持上传.xls .xlsx文件</div>
      </el-upload>
    </div>

    <p>注释：</p>
    <p>个人卖家店铺对应表上传，对EXCEL校验</p>
    <p>文件内容：店铺，订单专员，BD</p>

    <p class="mt20">表单更新，以表格最后一次上传为准</p>
    <p>报表可删除</p>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import {
  importUrl
} from "./api";

export default {
  data() {
    return {
      importUrl,
      fileList: [],
      uploadHeader: {
        token: Cookies.get("token")
      },
    };
  },
  mounted() {
    
  },
  methods: {
    handleSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
      } else {
        this.$message.error(res.message || '上传失败')
      }
      this.fileList  = [];
    },
    handleError(err) {
      console.log(err);
      this.$message.error('上传失败，请稍后再试')
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.mt20 {
  margin-top: 20px;
}
.upload-container {
  width: 400px;
  height: 120px;
}
</style>
